import { UIElement } from '../ui-element';
import { Component } from '../../decorators/component.decorator';
import styles from './ui-slideview-detail.css';

/**
 * @class
 * @memberof SharedComponents
 * @element ui-slideview-detail
 * @augments {UIElement}
 * @alias UISlideViewDetail
 * @classdesc Represents a class for <code>ui-slideview-detail</code> element. It's a helper class meant to be used together with
 *      <code>ui-slideview</code> and <code>ui-slideview-main</code> components to create a slideView interface.
 * @slot
 * @example
 * <ui-slideview-detail id="detail-view-id">
 *     <h3>Detail View</h3>
 *     <p>This is the detail view content.</p>
 * </ui-slideview-detail>
 */
@Component({
    tag: 'ui-slideview-detail',
    styles,
})
export class UISlideViewDetail extends UIElement {}
